module.exports = __webpack_public_path__ + "static/media/cr.731d723e.svg";